import { Toaster } from 'react-hot-toast';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './App.css';
import LoginRegistration from './pages/LoginRegistration';
import DashboardLayout from './pages/Dashboard';
import UserManagement from './pages/UserManagement';
import CompletedComplaints from './pages/CompletedComplaints';
import ComplaintList from './pages/ComplaintList';
import ComplaintStatus from './pages/ComplaintStatus';

function App() {
  return (
    <Router>
      <Toaster position="bottom-center" reverseOrder={false} />
      <Routes>
        <Route path="/auth" element={<LoginRegistration />} />
        <Route path="/complaint/:id" element={<ComplaintStatus />} />

        {/* Dashboard routes with layout */}
        <Route path="/" element={<DashboardLayout />}>
          <Route index element={<ComplaintList />} /> {/* default page */}
          <Route path="complaints" element={<ComplaintList />} />
          <Route path="/complaints/completed" element={<CompletedComplaints />} />

          <Route path="users" element={<UserManagement />} />
        </Route>
      </Routes>
    </Router>
  );
}

export default App;


